/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';
import type { GitCommitDTO } from './GitCommitDTO';
import {
    GitCommitDTOFromJSON,
    GitCommitDTOFromJSONTyped,
    GitCommitDTOToJSON,
} from './GitCommitDTO';

/**
 * 
 * @export
 * @interface GitInfoDTO
 */
export interface GitInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof GitInfoDTO
     */
    attributeName: string;
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof GitInfoDTO
     */
    attributeType: AttributeTypeDTO;
    /**
     * 
     * @type {GitCommitDTO}
     * @memberof GitInfoDTO
     */
    commit: GitCommitDTO;
    /**
     * 
     * @type {string}
     * @memberof GitInfoDTO
     */
    currentBranch?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GitInfoDTO
     */
    remotes?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GitInfoDTO
     */
    repositoryDirty: boolean;
}



/**
 * Check if a given object implements the GitInfoDTO interface.
 */
export function instanceOfGitInfoDTO(value: object): value is GitInfoDTO {
    if (!('attributeName' in value) || value['attributeName'] === undefined) return false;
    if (!('attributeType' in value) || value['attributeType'] === undefined) return false;
    if (!('commit' in value) || value['commit'] === undefined) return false;
    if (!('repositoryDirty' in value) || value['repositoryDirty'] === undefined) return false;
    return true;
}

export function GitInfoDTOFromJSON(json: any): GitInfoDTO {
    return GitInfoDTOFromJSONTyped(json, false);
}

export function GitInfoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): GitInfoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeName': json['attributeName'],
        'attributeType': AttributeTypeDTOFromJSON(json['attributeType']),
        'commit': GitCommitDTOFromJSON(json['commit']),
        'currentBranch': json['currentBranch'] == null ? undefined : json['currentBranch'],
        'remotes': json['remotes'] == null ? undefined : json['remotes'],
        'repositoryDirty': json['repositoryDirty'],
    };
}

export function GitInfoDTOToJSON(value?: GitInfoDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeName': value['attributeName'],
        'attributeType': AttributeTypeDTOToJSON(value['attributeType']),
        'commit': GitCommitDTOToJSON(value['commit']),
        'currentBranch': value['currentBranch'],
        'remotes': value['remotes'],
        'repositoryDirty': value['repositoryDirty'],
    };
}

